// PD2 (docs/build-briefs/PD2-discount-approval-thresholds.md). The two discount approval thresholds are chosen from
// fixed lists, never typed: the percent in whole steps, the dollars in whole-dollar steps. A stored value that is not on
// the list (set by an older build or an override) is still offered, so opening the picker never changes it.

export const DISCOUNT_APPROVAL_PERCENT_CHOICES: readonly number[] = [
  5, 10, 15, 20, 25, 30, 40, 50, 75, 100,
];
export const DISCOUNT_APPROVAL_DOLLAR_CHOICES: readonly number[] = [
  5, 10, 15, 20, 25, 30, 40, 50, 75, 100, 150, 200,
];

export type DiscountApprovalPickKind = "percent" | "dollars";

/** Option values are basis points for the percent pick and cents for the dollar pick, the units the server stores. */
export function discountApprovalOptions(
  kind: DiscountApprovalPickKind,
  current: number,
): Array<{ value: number; label: string }> {
  const choices =
    kind === "percent" ? DISCOUNT_APPROVAL_PERCENT_CHOICES : DISCOUNT_APPROVAL_DOLLAR_CHOICES;
  const options = choices.map((choice) => ({
    value: choice * 100,
    label: kind === "percent" ? `${choice}%` : `$${choice}`,
  }));
  if (!options.some((option) => option.value === current)) {
    options.push({ value: current, label: discountApprovalLabel(kind, current) });
    options.sort((a, b) => a.value - b.value);
  }
  return options;
}

export function discountApprovalLabel(kind: DiscountApprovalPickKind, value: number): string {
  if (kind === "percent") {
    return value % 100 === 0 ? `${value / 100}%` : `${(value / 100).toFixed(2)}%`;
  }
  return value % 100 === 0 ? `$${value / 100}` : `$${(value / 100).toFixed(2)}`;
}

/** Fills a select with the picks and selects the current value. */
export function fillDiscountApprovalSelect(
  select: HTMLSelectElement,
  kind: DiscountApprovalPickKind,
  current: number,
): void {
  select.replaceChildren();
  for (const option of discountApprovalOptions(kind, current)) {
    const element = document.createElement("option");
    element.value = String(option.value);
    element.textContent = option.label;
    select.append(element);
  }
  select.value = String(current);
}
